module.exports = __webpack_public_path__ + "img/mallforindia.3e765beb.png";